import axios from 'axios';
import ConfigAxios from './ConfigAxios';

const getAllMethods = () => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.get(NERTHUS + '/catalogs/paymethods', options);
};

const getMethodById = dataClientId => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.get(NERTHUS + '/catalogs/paymethods/code/' + dataClientId, options);
};

const createMethod = dataClient => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.post(NERTHUS + '/catalogs/paymethods', dataClient, options);
};

const updateMethod = (dataClient, dataClientId) => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.put(NERTHUS + '/catalogs/paymethods/' + dataClientId, dataClient, options);
};

const deleteMethod = dataClientId => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.delete(NERTHUS + '/catalogs/paymethods/' + dataClientId, options);
};

const uploadImagesMethod = (idMethod, dataImages) => {
  let {NERTHUS, options} = ConfigAxios();
  let auth = options.headers.Authorization;
  let optionsZip = {
    headers: {
        'Authorization': auth
        
    }}
  return axios.post(NERTHUS + '/catalogs/paymethods/upMethodImages/'+ idMethod, dataImages, optionsZip);
};

const PayMethodCrudService = {
  getAllMethods,
  getMethodById,
  createMethod,
  updateMethod,
  deleteMethod,
  uploadImagesMethod
};

export default PayMethodCrudService;